(function (module) {
    module.directive('uploadDocument', function ($timeout) {
        return {
            restrict: 'AE',
            scope: {
                model: '=',
                modelType: '=',
                modelId: '='
            },
            controller: function ($rootScope, $scope, FileUploader) {

                $scope.documentUploader = new FileUploader({
                    url: '/api/upload-documents',
                    headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
                    autoUpload: true
                });

                $scope.documentType = 'Vergi Levhası';
                $scope.documentUploader.onBeforeUploadItem = function (item) {
                    item.formData = [
                        {
                            model_id: $scope.modelId,
                            model_type: $scope.modelType,
                            type: $scope.documentType
                        }
                    ];
                    console.log(item)
                };

                $scope.documentUploader.filters.push({
                    name: 'formatFilter',
                    fn: function (item /*{File|FileLikeObject}*/, options) {
                        var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                        if ('|jpg|png|pdf|doc|'.indexOf(type) === -1) {
                            alert('Sadece jpg,png,pdf,doc formatları desteklenmektedir.');
                            return false;
                        };
                        return true;
                    }
                });

                $scope.documentUploader.onAfterAddingFile = function (fileItem) {
                    $scope.progress = true;
                    $scope.pending = true;
                };

                $scope.documentUploader.onCompleteItem = function (item, response, status, headers) {
                    $scope.progress = false;
                    console.log($scope.model)
                    $scope.model.documents.push(response.document);
                    if (response.status == 'success') {
                        $scope.pending = false;
                    }
                }
            },
            templateUrl: "modules/directive/upload-document.html",

        };
    });
}(angular.module("uploadDocument", [])));